import React from 'react';
import { Checkbox } from '@mui/material';
import { useDispatch } from 'react-redux';
import { usePoliciesSelect } from '@/context/policiesContext';

const PolicyTransactionRowCheckbox = ({ policy }) => {
	const { selectedPolicies, setSelectedPolicies } = usePoliciesSelect();

	const checkboxChecked = selectedPolicies.some((s) => s?.Id === policy?.Id);

	const disabled = !policy?.ClientDocId;

	const handleChange = () => {
		const exists = selectedPolicies.some((p) => p.Id === policy.Id);
		const updated = exists
			? selectedPolicies.filter((p) => p.Id !== policy.Id)
			: [...selectedPolicies, policy];
		setSelectedPolicies(updated);
	};

	return (
		<Checkbox
			disabled={disabled}
			checked={checkboxChecked}
			onClick={(e) => e.stopPropagation()}
			onChange={handleChange}
		/>
	);
};

export default PolicyTransactionRowCheckbox;
